const skipBtn = document.querySelector(".skipToMainContent");
const mainContent = document.querySelector("#main");
skipBtn.addEventListener("click", function () {
    mainContent.focus();
});
